export type PurchaseResult={status:string;accepted:number;rejected:number;pending:number;acceptedMinor:number;items:{cardId:string;operationId:string;status:string;amountMinor:number;code?:string;cardStatus?:string}[]};

// Normal queue progress is distinct from uncertain payment, refund or review.
export function purchaseInProgress(result:PurchaseResult|null){
 if(!result||result.pending<=0)return false;
 const unfinished=result.items.filter(item=>!['Accepted','Rejected','Refunded'].includes(item.status));
 return unfinished.length>0&&unfinished.every(item=>['Ready','Sending','Debited'].includes(item.status)&&!item.code);
}

// A transport failure is not proof of a rejected payment. Only the durable
// receipt decides which selections are accepted, rejected, or still pending.
export function purchaseSummary(result:PurchaseResult|null,t:(key:string,values?:Record<string,string|number>)=>string){
 if(!result)return '';
 const unit=t('receipt.unit');
 // Render only confirmed progress already present in the receipt; no separate
 // count request. The initial zero is not a purchase outcome.
 if(purchaseInProgress(result)&&result.rejected===0&&!result.items.some(i=>i.code||i.status==='Refunded'))
  return [result.accepted>0?t('receipt.accepted',{count:result.accepted,unit}):'',t('receipt.pending',{count:result.pending})].filter(Boolean).join('. ');
 const counts=result.accepted>0?[t('receipt.accepted',{count:result.accepted,unit})]:[];
 if(result.rejected)counts.push(t('receipt.rejected',{count:result.rejected,unit}));
 if(result.pending)counts.push(t('receipt.pending',{count:result.pending}));
 const parts=counts.length?[counts.join(', ')+(result.pending?'':'.')]:[];
 const codes=new Set(result.items.map(i=>i.code));
 if(codes.has('merchant_402')||codes.has('insufficient_balance'))parts.push(t('receipt.balance'));
 if(codes.has('sales_closed')||codes.has('wrong_draw'))parts.push(t('receipt.closed'));
 if(codes.has('amount_limit')||codes.has('merchant_405'))parts.push(t('receipt.amountLimit'));
 if(codes.has('amount_step'))parts.push(t('receipt.amountStep'));
 if(['session_expired','merchant_401','merchant_404','merchant_409'].some(c=>codes.has(c)))parts.push(t('receipt.session'));
 if(codes.has('bet_not_found'))parts.push(t('receipt.notDebited'));
 if(result.items.some(i=>i.status==='RefundPending'))parts.push(t('receipt.refundPending'));
 if(result.items.some(i=>i.status==='Refunded'))parts.push(t('receipt.refunded'));
 if(result.items.some(i=>(i.status==='Unknown'||i.status==='Review')&&i.cardStatus==='NotAccepted'))parts.push(t('receipt.notIncluded'));
 else if(result.items.some(i=>i.status==='Review'))parts.push(t('receipt.review'));
 else if(result.items.some(i=>i.status==='Debited'))parts.push(t('receipt.debited'));
 else if(result.items.some(i=>i.status==='Sending'||i.code==='service_unavailable'))parts.push(t('receipt.waiting'));
 else if(result.rejected>0&&parts.length===1)parts.push(t('receipt.notApproved'));
 return parts.join(' ');
}
